module.exports = __webpack_public_path__ + "media/bundles/TriipApp/assets/images/home-guess__mobile-08813651b06d2df4a8a627c9ccc9203f.jpg";